import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteRight = function SvgRteRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.994 4H15a1 1 0 010 2H4.994a1 1 0 010-2zm3 4a1 1 0 011.009-1h6.005c.548 0 .992.444.992 1 0 .552-.453 1-.998 1h-6.01a.997.997 0 01-.997-1zm-3 2H15a1 1 0 010 2H4.994a1 1 0 010-2zm4 3H15a1 1 0 010 2H8.994a1 1 0 010-2z"
  })));
};
var RteRight = SvgRteRight;

export { RteRight as default };
